class ServiceClientError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ServiceClientError';
  }
}

export const throwMessage = (func, klassName) => {
  return `${func} from ${klassName} is not defined`;
};

export default ServiceClientError;
